// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 10L8 18.6603L8 1.33975L23 10ZM4 1L6 1L6 23H4L4 1Z"}}]};

const Flag3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flag-3-filled',
    ref,
    icon: element,
  },
));

Flag3FilledIcon.displayName = 'Flag3FilledIcon';

export default Flag3FilledIcon;
